import { useQuery } from "@tanstack/react-query";

import { getFavoriteWords, getWordsBySetId } from "@/api/words";
import type { FlashcardWord } from "@/types/common";

const mapWordsToFlashcards = (rows: Array<{ id: string; word: string; meaning: string }>): FlashcardWord[] =>
  rows.map(row => ({
    id: row.id,
    word: row.word,
    meaning: row.meaning,
  }));

/** 특정 세트의 단어 목록 조회 */
export function useWordsQuery(setId: string | undefined) {
  return useQuery({
    queryKey: ["words", setId],
    queryFn: () => getWordsBySetId(setId!),
    enabled: Boolean(setId) && setId !== "favorites",
    select: mapWordsToFlashcards,
  });
}

/** 즐겨찾기 단어 목록 조회 */
export function useFavoriteWordsQuery(userId: string | undefined) {
  return useQuery({
    queryKey: ["words", "favorites", userId],
    queryFn: () => getFavoriteWords(userId!),
    enabled: Boolean(userId),
    select: mapWordsToFlashcards,
  });
}
